/** Default landing route — target of the "/" and 404 redirects and "go home" actions. */
export const HOME_ROUTE = '/auth/vendors';
